<div class="row ba-btn-row my-2">
  <div class="col-sm-12 col-md-8">
    <button class="ba-btn ba-btn-contrast ba-btn-icon ba-icon-trash-before" [ngClass]="btnClass"
            (click)="deleteEvent.emit()"
            [id]="_id">{{btnLabel}}
    </button>
  </div>
</div>
